


















































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import type { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DialogoDeEdicaoDeFornecedor from '@/components/fornecedor/DialogoDeEdicaoDeFornecedor.vue'

/** Card de identificação da nota (fornecedor/loja/número/série/emissão/itens). */
@Component({
	components: { DialogoDeEdicaoDeFornecedor },
})
export default class CabecalhoDaNota extends Vue {
	@Prop({ type: Object, required: true }) importacao!: ImportacaoDeNota
	@Ref() readonly dialogoDeFornecedor!: { mostrar: (f: any, novo: boolean) => Promise<any> }

	salvandoFornecedor = false

	get fornecedorEncontrado(): boolean {
		return !!(this.importacao.fornecedor && this.importacao.fornecedor.encontrado)
	}

	async editarFornecedor() {
		if (!this.importacao.fornecedor || !this.importacao.fornecedor.encontrado) return
		const fornecedor = await this.dialogoDeFornecedor.mostrar(this.importacao.fornecedor.encontrado, false)
		if (fornecedor) this.$set(this.importacao.fornecedor, 'encontrado', fornecedor)
	}

	async cadastrarFornecedor() {
		const nota: any = this.importacao.fornecedor ? this.importacao.fornecedor.nota : null
		if (!nota) return
		try {
			this.salvandoFornecedor = true
			const fornecedor = await this.dialogoDeFornecedor.mostrar({
				...nota,
				id: '',
				tipoFornecedor: 'Compra',
				markup: 0,
				gruposEconomicos: [],
				isEntregaExpressa: false,
			}, true)
			if (fornecedor) this.$set(this.importacao.fornecedor, 'encontrado', fornecedor)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvandoFornecedor = false
		}
	}

	get nomeFornecedor(): string {
		const f = this.importacao.fornecedor
		return f && f.encontrado ? f.encontrado.razaoSocialOuNome : (f && f.nota ? f.nota.razaoSocialOuNome : '—')
	}

	get nomeLoja(): string {
		return this.importacao.lojaDestinoDaImportacao ? this.importacao.lojaDestinoDaImportacao.nome : '—'
	}

	get totalItens(): number {
		return this.importacao.produtos ? this.importacao.produtos.length : 0
	}

	/** Chave de acesso (44 dígitos) — embute série [pos 22-24] e nNF [pos 25-33]. */
	private get chave(): string {
		const ch = this.importacao.chNfe || ''
		return ch.length === 44 ? ch : ''
	}

	get numeroNota(): string {
		if (this.importacao.nnf) return String(this.importacao.nnf)
		return this.chave ? String(parseInt(this.chave.substr(25, 9), 10)) : '—'
	}

	get serieNota(): string {
		if (this.importacao.serie) return String(this.importacao.serie)
		return this.chave ? String(parseInt(this.chave.substr(22, 3), 10)) : '—'
	}

	get emissao(): string {
		const d = this.importacao.dhEmi
		if (!d) return '—'
		// dhEmi pode vir "2026-05-11T16:20:00-03:00" ou já formatada "11/05/2026"
		const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d)
		return m ? `${m[3]}/${m[2]}/${m[1]}` : d
	}
}
